
import api from './api';

class Receipt {

	constructor (Api, Session) {
		this.Api = Api;
	}

	getDetails (query) {
		return this.Api.get({
			url:  'v1.1/m/receiptsDetails',
			query
		});
	}

}

Receipt.$inject = ['Api'];

export default angular.module('service.receipt', [api])
	.service('Receipt', Receipt)
	.name;



// WEBPACK FOOTER //
// ./src/service/receipt.js